import claimingProcessReducer from 'components/ClaimingProcess/state/reducer';
import cleaningReportsReducer from 'components/CleaningReport/components/CleaningReportList/state/reducer';
import cleaningMachineUtiReducer from 'components/CleaningReport/components/CleaningReportUtilization/state/reducer';
import cleaningTaskCompletionReducer from 'components/CleaningReport/components/CleaningTaskCompletion/state/reducer';
import machineCleaningAreaReducer from 'components/MyMachineDetails/components/MachineCleaningArea/state/reducer';
import machineDetailsReducer from 'components/MyMachineDetails/state/reducer';
import notificationsReducer from 'components/Notifications/components/NotificationList/state/reducer';
import operatorsReducer from 'components/Operators/components/state/reducer';
import machineOverviewReducer from 'components/Overview/state/reducer';
import notificationOverviewReducer from 'components/Overview/components/NotificationOverview/state/reducer';
import machineVncSessionReducer from 'components/MachineVnc/state/reducer';
import { combineReducers } from 'redux';
import authReducer from './global/auth/reducer';
import errorReducer from './global/error/reducer';
import machineListReducer from './global/machine/reducer';
import subscriptionReducer from './global/subscription/reducer';
import profileReducer from './global/profile/reducer';
import exportReducer from './global/export/reducer';
import legalReducer from './global/legal/reducer';

const rootReducer = combineReducers({
  // Global reducers (sharing global app)
  auth: authReducer,
  machines: machineListReducer,
  error: errorReducer,
  subscription: subscriptionReducer,
  profile: profileReducer,
  export: exportReducer,
  legal: legalReducer,
  machineVncSession: machineVncSessionReducer,

  // Component reducers
  machineOverview: machineOverviewReducer,
  machineCleaningArea: machineCleaningAreaReducer,
  notifications: notificationsReducer,
  cleaningReports: cleaningReportsReducer,
  cleaningTaskCompletion: cleaningTaskCompletionReducer,
  cleaningMachineUtilisation: cleaningMachineUtiReducer,
  claimingProcess: claimingProcessReducer,
  notificationOverview: notificationOverviewReducer,
  machineDetails: machineDetailsReducer,
  operators: operatorsReducer
});

export default rootReducer;
